import { render, staticRenderFns } from "./DetailMedServicePayment.vue?vue&type=template&id=2788203c&scoped=true"
import script from "./DetailMedServicePayment.vue?vue&type=script&lang=js"
export * from "./DetailMedServicePayment.vue?vue&type=script&lang=js"
import style0 from "./DetailMedServicePayment.vue?vue&type=style&index=0&id=2788203c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788203c",
  null
  
)

export default component.exports